export enum ErrorCode {
  GENERIC = 1,
  FORM_FIELD = 2,
  WIDGET = 3,
}
